import { getGenerationByFuelTypeChartData } from "api/dataVisualisation/generationByFuelType/generationByFuelType";
import { getAllFuelTypes } from "api/dataVisualisation/reference/reference";
import useRequest, { RequestStatus } from "hooks/useRequest";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { OutturnSummaryModel } from "models/outturnSummaryModel";
import { useCallback } from "react";
import { combineRequestStatuses } from "utils/requestHelpers";

const useGenerationByFuelTypeChartContainerData = (
  dateFilter: DateFilterModel
): {
  data: {
    fuelTypes: string[];
    generationByFuelTypeData: OutturnSummaryModel[];
  } | null;
  status: RequestStatus;
  fetchData: () => void;
} => {
  const {
    data: fuelTypes,
    status: fuelTypesStatus,
    request: fetchFuelTypes,
  } = useRequest(getAllFuelTypes);

  const {
    data: generationByFuelTypeData,
    status: generationByFuelTypeStatus,
    request: fetchGenerationByFuelTypeData,
  } = useRequest(getGenerationByFuelTypeChartData);

  const fetchData = useCallback(() => {
    if (!fuelTypes?.length) {
      fetchFuelTypes();
    }
    fetchGenerationByFuelTypeData(dateFilter);
  }, [
    dateFilter,
    fetchFuelTypes,
    fetchGenerationByFuelTypeData,
    fuelTypes?.length,
  ]);

  const data =
    fuelTypes && generationByFuelTypeData
      ? {
          fuelTypes,
          generationByFuelTypeData,
        }
      : null;

  const status = combineRequestStatuses(
    fuelTypesStatus,
    generationByFuelTypeStatus
  );

  return {
    data,
    status,
    fetchData,
  };
};

export default useGenerationByFuelTypeChartContainerData;
